/**
 * Gráfico empilhado e pizza com muitas séries: a série (ou fatia) zerada no período só ocupa a legenda.
 * Aqui ela sai do gráfico. A série de linha fica, mesmo zerada (é a referência do card), e a comparação de
 * períodos, o orçamento e os objetivos não passam por aqui (lá cada série tem par, e o par não pode sumir).
 */

const pointValue = (point) => {
    if (point === null || point === undefined) return 0;
    if (typeof point === "number") return point;
    if (Array.isArray(point)) return Number(point[1]) || 0;
    return Number(point.y) || 0;
};

const isStackedChart = (structure = {}) =>
    Boolean(
        structure?.plotOptions?.column?.stacking ||
            structure?.plotOptions?.series?.stacking
    );

// `stack` sozinho não empilha: o pro-v2 grava `stack: "value"` também nas colunas lado a lado.
const isStackedSerie = (serie) => !["line", "spline", "area", "areaspline"].includes(serie?.type);

export const isEmptySerie = (serie) =>
    !(serie?.data || []).some((point) => pointValue(point) !== 0);

/**
 * As séries do gráfico sem as empilhadas que não têm valor no período. Se nada sobra para empilhar, devolve
 * como veio: o card mostra os zeros em vez de um gráfico vazio.
 */
export function withoutEmptyStackedSeries(series, structure, { comparing = false } = {}) {
    if (!Array.isArray(series) || comparing || !isStackedChart(structure)) return series;
    const visible = series.filter((serie) => !isStackedSerie(serie) || !isEmptySerie(serie));
    return visible.some(isStackedSerie) ? visible : series;
}

/**
 * Fatias da pizza: a zerada sai, e a negativa, que a pizza não desenha, também. Pizza toda zerada fica só sem as
 * negativas, como antes: a legenda mostra os tipos com 0%, em vez de um card em branco.
 */
export function withoutEmptySlices(points = []) {
    const drawable = points.filter((point) => pointValue(point) >= 0);
    const withValue = drawable.filter((point) => pointValue(point) > 0);
    return withValue.length ? withValue : drawable;
}
